module.exports = __webpack_public_path__ + "front/img/c4.c8656703.png";